import Select from '@mui/material/Select';
import styled from 'styled-components';

import MenuItem from '@mui/material/MenuItem';

export const StyledDocumentTypeSelector = styled(Select)`
    height: 40px;
`;

export const StyledDocumentsTypeMenuItem = styled(MenuItem)`
    color: rgba(0, 0, 0, 0.6);
`;
